import { render } from "./ClientList.vue?vue&type=template&id=6dc3cf6c&scoped=true"
import script from "./ClientList.vue?vue&type=script&lang=js"
export * from "./ClientList.vue?vue&type=script&lang=js"

import "./ClientList.vue?vue&type=style&index=0&id=6dc3cf6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc3cf6c"]])

export default __exports__